/**
 * Micro-shelf category URLs that Wave 1 retargets onto parents.
 * proxy.ts issues an HTTP 308 before render. The category page keeps the
 * same map as a fallback. Do not add a destination that is itself a key.
 */
export const MERGED_CATEGORY_REDIRECTS: Readonly<Record<string, string>> = {
  'soccer-football': 'sports',
  'pro-wrestling-mma': 'sports',
  'retro-gaming': 'modern-gaming',
  'spongebob-nickelodeon': 'cartoons-animation',
  'hip-hop-r-b': 'music',
  'jingles-ringtones': 'music',
  'discord-app-sounds': 'retro-tech',
  'adult-animation': 'movies',
  // X2: the library has one shelf each for memes and for movies and TV.
  // Destinations are final hubs (no chains); GSC clicks, 28 days to
  // 2026-09-30: internet-culture 3, funny 0, tv-shows 2.
  'internet-culture': 'memes',
  funny: 'memes',
  'tv-shows': 'movies',
  // Retired DB names that were never hubs; they 404'd before.
  'comedy-sound-effects': 'sound-effects',
  'international-memes': 'memes',
}

export function mergedCategoryRedirectPath(slug: string): string | null {
  const destination = MERGED_CATEGORY_REDIRECTS[slug]
  return destination ? `/sounds/category/${destination}` : null
}
